
import React from 'react'
import './index.less'
console.log(React)
export default function TopVideo(props) {
  return (<div className={`topVideo ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}>
    <div className='topVideo_div1'>
      <i className='icon'><svg width='48' height='48' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fill-rule='evenodd'><path d='M16.5 8A1.5 1.5 0 0118 9.5v2.25l4.2-3.15a.5.5 0 01.8.4v10a.5.5 0 01-.8.4L18 16.25v2.25a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 015 18.5v-9A1.5 1.5 0 016.5 8h10z' fill='url(#a)' fill-rule='nonzero'></path><path d='M5.25 1a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5z' fill='#C7C7C7'></path></g></svg></i>
      <button className='button' onMouseDown={(e) => {
        e.stopPropagation()
      }} onClick={() => {
        props.hoistPopup && props.hoistPopup()
      }}>上传视频</button>
    </div>
    <div className='topVideo_div2'></div>
  </div>)
}
